import React, { useMemo } from "react";

const Plane = ({ activeSwitch }) => {
  const returnMaterial = useMemo(() => {
    if (activeSwitch === 0) {
      return (
        <meshStandardMaterial
          attach="material"
          color="#001a1a"
          roughness={0.8}
        />
      );
    } else if (activeSwitch === 1) {
      return (
        <meshStandardMaterial
          attach="material"
          color="#1a1a00"
          roughness={0.7}
        />
      );
    } else {
      return (
        <meshStandardMaterial
          attach="material"
          color="#000033"
          roughness={0.9}
        />
      );
    }
  }, [activeSwitch]);
  return (
    <group>
      <mesh position={[0, 0, -5]} receiveShadow>
        <planeBufferGeometry attach="geometry" args={[10000, 10000]} />
        {returnMaterial}
      </mesh>
    </group>
  );
};

export default Plane;
